import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { element } from 'protractor';

@Component({
  selector: 'app-supp-inv-payment-method',
  templateUrl: './supp-inv-payment-method.component.html',
  styleUrls: ['./supp-inv-payment-method.component.css']
})
export class SuppInvPaymentMethodComponent implements OnInit {

  private dp = [];
  displayedColumns = ['payment_type_name', 'amount', 'choose'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  total_amount: string;
  total_entered = '0';
  dp1 = [];
  // type = '';

  Pay_Method_Msg; Equal_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<SuppInvPaymentMethodComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Pay_Method_Msg').subscribe((res: string) => {
      this.Pay_Method_Msg = res;
    });

    translate.get('Equal_Msg').subscribe((res: string) => {
      this.Equal_Msg = res;
    });
  }

  ngOnInit() {

    if (this.dialog_data['all_payment_types'] != undefined) {
      this.dp = this.dialog_data['all_payment_types'];
      // if (this.applicationConstants.user_lang == 'en') {
      //   this.dp.forEach(element => {
      //     element.payment_type_name = element.payment_type_name_en;
      //   });
      // }
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;
    }
    // else
    // {
    //   let query = this.queryList.all_paymentType;
    //   let obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();
    //       this.dp = data.data['list'];
    //       if (this.dp.length == 5)
    //         this.dp.splice(4, 1);



    //       this.dataSource = new MatTableDataSource(this.dp);
    //       this.dataSource.sort = this.sort;
    //     });
    // }
    this.total_amount = this.dialog_data['total_amount'];

    let total_entered = 0;
    if (this.dialog_data['payment_methods'] != undefined) {
      let payment_methods = this.dialog_data['payment_methods'];
      payment_methods.forEach(element => {
        total_entered += Number(element.amount);
      });
      this.total_entered = total_entered.toFixed(2);
    }

    // if (this.dialog_data['type'] != undefined)
    //   this.type = this.dialog_data['type'];
    
  }

  ngAfterViewInit() {
    // added for the update by Hassan 11-24-2019 (START)
    //console.log(this.dialog_data['payment_methods'].length);
    if (this.dialog_data['payment_methods'] != undefined && this.dialog_data['payment_methods'].length > 0) {
      console.log(this.dp);
      //console.log(this.dp1);
      this.dp1 = this.dialog_data['payment_methods'];
      this.dp.forEach(pmd => {
        this.dp1.forEach(pt => {
          //console.log(pmd['payment_type_id'] + '----'+pt['payment_type_id'])  
          if (pmd['payment_type_id'] == pt['payment_type_id']) {
            (document.getElementById('amount' + pmd['payment_type_id']) as HTMLInputElement).value = pt['amount'];
            //if(pt['amount'] != '' && pt['amount'] != '0' && pt['flag'] != 'new' )
            //pmd['flag'] = pt['flag'];
            //pmd['amount'] = pt['amount'];
            (document.getElementById('flag' + pmd['payment_type_id']) as HTMLInputElement).value = pt['flag'];
            (document.getElementById('inv_payment_method_id' + pmd['payment_type_id']) as HTMLInputElement).value = pt['inv_payment_method_id'];
            
          }
        });

      }
      );

    }
    // END 
  }

  total(row) {
    this.total_entered = '0';
    // added for update 
    let amount = (document.getElementById('amount' + row['payment_type_id']) as HTMLInputElement).value;
    let flag = (document.getElementById('flag' + row['payment_type_id']) as HTMLInputElement).value;
    // console.log('---- ' + (document.getElementById('flag' + row['payment_type_id']) as HTMLInputElement).value);
    console.log(amount + '----' + flag);
    if (flag != 'new' && (amount == '0' || amount == '')) {
      let inv_payment_method_id = (document.getElementById('inv_payment_method_id' + row['payment_type_id']) as HTMLInputElement).value;

      if (inv_payment_method_id == '' || inv_payment_method_id == null || inv_payment_method_id == undefined ||
        inv_payment_method_id == 'undefined')
        (document.getElementById('flag' + row['payment_type_id']) as HTMLInputElement).value = '';
      else
        (document.getElementById('flag' + row['payment_type_id']) as HTMLInputElement).value = 'delete';
    }
    else if (flag != 'new' && flag != '')
      (document.getElementById('flag' + row['payment_type_id']) as HTMLInputElement).value = 'update';
    else if (flag == 'new' && (amount == '0' || amount == ''))
      (document.getElementById('flag' + row['payment_type_id']) as HTMLInputElement).value = '';
    else
      (document.getElementById('flag' + row['payment_type_id']) as HTMLInputElement).value = 'new';

    console.log(amount + '----' + (document.getElementById('flag' + row['payment_type_id']) as HTMLInputElement).value);

    this.dp.forEach(element => {
      let payment_type_id = element['payment_type_id'];
      let amount = document.getElementById('amount' + payment_type_id) as HTMLInputElement;
      if (amount.value != '') {
        this.total_entered = (Number(this.total_entered) + Number(amount.value)).toFixed(2);
      }
    });
  }

  choose(row) {
    let remainder = 0;
    if (Number(this.total_entered) < Number(this.total_amount))
      remainder = Number(this.total_amount) - Number(this.total_entered);
    let payment_type_id = row['payment_type_id'];
    let amount = document.getElementById('amount' + payment_type_id) as HTMLInputElement;
    amount.value = String(remainder.toFixed(2));
    this.total(row);
    this.save();    // 'save'
  }


  save() {
    if (this.total_entered != '0' && Number(this.total_amount) == Number(this.total_entered)) {

      // this.dialog_data = [];
      this.dialog_data = { 'payment_methods': [], 'all_payment_types': [] };
      // if (this.type != '')  type
      //   this.dialog_data['op_type'] = type;

      this.dp.forEach(element => {
        let payment_type_id = element['payment_type_id'];
        let amount = (document.getElementById('amount' + payment_type_id) as HTMLInputElement).value;
        element['amount'] = amount;
        let flag = (document.getElementById('flag' + payment_type_id) as HTMLInputElement).value;
        element['flag'] = flag;
        let inv_payment_method_id = (document.getElementById('inv_payment_method_id' + payment_type_id) as HTMLInputElement).value;
        element['inv_payment_method_id'] = inv_payment_method_id;
 
        if (amount != '' && Number(amount) != 0) {
          let payment_methods = {
            'payment_type_id': element['payment_type_id'],
            'payment_type_key': element['payment_type_key'],
            'flag': (flag != undefined ? flag : ''),
            'key': element.key,
            'payment_type_name': element['payment_type_name'],
            'payment_type_name_en': element['payment_type_name_en'],
            'amount': amount,
            'total_entered': this.total_entered,
            'inv_payment_method_id': (inv_payment_method_id != 'undefined' ? inv_payment_method_id : '')
          };
          // this.dialog_data.push(payment_methods);
          this.dialog_data['payment_methods'].push(payment_methods);
        }
        this.dialog_data['all_payment_types'].push(element);
      });
      this.dialog_data['op_type'] = "success";
      this.dialogRef.close(this.dialog_data);
    }

    else if (this.total_entered == '0')
      alert(this.Pay_Method_Msg);

    else if (Number(this.total_amount) != Number(this.total_entered))
      alert(this.Equal_Msg);
  }

  cancel() {
    // if (this.type != '')
    //   this.dialog_data['op_type'] = 'save';
    this.dialog_data = { 'op_type': 'cancel' };  
    this.dialogRef.close(this.dialog_data);
  }

}
